import Channels from '../base/channels';
import Env from '../base/env';
import Component from 'gia/Component';
import gsap from 'gsap';

export default class Module extends Component
{
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    //! Fns
    this.events()
    gsap.delayedCall(1,()=>{
      window.scrollTo(0,0)
    })

    this.funcLaunch = this._fx.bind(this)

    Channels.on('launcher::exit',this.funcLaunch)
    Channels.on('transition::end',this.funcLaunch)
  }

  _fx()
  {
    this.animate()
  }

  animate()
  {
    this.animation = gsap.timeline({ delay: .5 })
    this.animation.add([
      gsap.fromTo(
        this.DOM.view.querySelectorAll('.fxReveal'),
        {
          autoAlpha:0,
          y:30
        },
        {
          autoAlpha:1,
          y:0,
          ease:'quint.out',
          duration:1,
          stagger:.1
        }
      )
    ])
  }

  close()
  {
    gsap.to(
      this.ref.formMaster,
      {
        x:'100%',
        ease:'quint.inOut',
        duration:.7,
        onStart:()=>{
          document.body.classList.remove('can-scroll'),
          this.refreshScroll()
        },
        onComplete:()=>{
          Env.$html.classList.remove('hide-ui')
        }
      }
    )
    gsap.to(
      window,{
        scrollTo:{
          y:0,
          duration:.5,
          ease:'cubic.out'
        }
      }
    )
  }

  enable(index)
  {
    gsap.set(this.ref.formEntry, { display: 'none' })
    for(let form of this.ref.formEntry) {
      const getSlug = form.getAttribute('data-type')
      if(getSlug == index) {
        gsap.set(form, { display: 'block' })
        break;
      }
    }

  }

  events()
  {
    for(let [i,trigger] of this.ref.formTrigger.entries()) {
      trigger.addEventListener('click',()=>{
        this.open()
        this.enable(trigger.getAttribute('data-type'))
      })
    }
    for(let trigger of this.ref.btnBackHeader) {
      trigger.addEventListener('click',()=>{
        this.close()
      })
    }
    this.ref.btnBack[0].addEventListener('click',()=>{
      this.close()
    })
  }

  open()
  {
    gsap.fromTo(
      this.ref.formMaster,
      {
        x:'100%'
      },
      {
        x:0,
        ease:'quint.out',
        duration:.7,
        onStart:()=>{
          document.body.classList.add('can-scroll')
          this.refreshScroll()
          Env.$html.classList.add('hide-ui')
        }
      }
    )
  }

  refreshScroll()
  {
    setTimeout(() => {
      if(typeof Env.framework.UI.smoothie != 'undefined') {
        Env.framework.UI.smoothie.update()
      }
    }, 250);
  }

  unmount()
  {
    Channels.removeListener('launcher::exit',this.funcLaunch)
    Channels.removeListener('transition::end',this.funcLaunch)
  }
}
